import React from 'react';
import '../RenderLegacyCusto.scss';

import ChannelTile from './ChannelTile';

const ChannelCategory = ({ category }) => {
  return (
    <div className="GW_category">
      <span className="GW_categoryTitulo">{category.label}</span>
      {category.channels.map((channel) => (
        <ChannelTile key={channel.label} channel={channel} />
      ))}
    </div>
  );
};

export default ChannelCategory;
